
export default {
  props: {
    product: {
      default: () => {
        return {
          imagePath: '',
          comments: [],
        }
      },
    },
  },
  methods: {
    SET_DATE(date) {
      return this.$date.format(date)
    },
  },
}
